import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { TopoloAuthProvider } from '@topolo-io/app-shell';
import '@topolo-io/design-tokens/tokens.css';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000,
      retry: 1,
    },
  },
});

async function boot() {
  const [{ default: App }, { topoloAuth }] = await Promise.all([
    import('./App'),
    import('./lib/topolo-auth'),
  ]);

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <TopoloAuthProvider auth={topoloAuth}>
            <App />
          </TopoloAuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </StrictMode>
  );
}

void boot();
